import { DateState } from "stores/wizard/state/global/date";

export const dateState = (): DateState => {
  const today = new Date();

  return {
    start: new Date(today),
    end: new Date(today.setDate(today.getDate() + 1))
  };
};
